module.exports = __webpack_public_path__ + "static/img/join_img1.a51b1b76.png";